/* eslint-disable camelcase */
import React, { useCallback, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import logoImg from '../../assets/logo.svg';

import { Container, Content, Background } from './styles';

import Input from '../../components/Input';
import Button from '../../components/Button';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import getValidationErrors from '../../utils/getValidationErrors';

interface CreateCredentialsData {
  clientUsername: string;
  clientPassword: string;
}

const CriarCredenciais: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const [loading, setLoading] = useState(false);

  const { addToast } = useToast();

  const history = useHistory();
  const location = useLocation();

  const handleSubmit = useCallback(
    async (data: CreateCredentialsData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          clientUsername: Yup.string().required('Nome é obrigatório'),
          clientPassword: Yup.string().required('Senha obrigatória'),
          password_confirmation: Yup.string().oneOf(
            [Yup.ref('clientPassword')],
            'Confirmação de senha incorreta',
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const { clientUsername, clientPassword } = data;
        const token = location.search.replace('?token=', '');

        if (!token) {
          throw new Error();
        }

        setLoading(true);
        await api.post('/client/create/credentials', {
          clientUsername,
          clientPassword,
          token,
        });

        setLoading(false);
        history.push('/');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao cadastrar credenciais',
          description:
            'Ocorreu um erro ao cadastrar sua credencial, tente novamente.',
        });
      }
    },
    [addToast, history, location.search],
  );
  return (
    <Container>
      <div className="sideBar">
        <div>
          <h1>UM PEQUENO-ALMOÇO DE HOTEL À SUA PORTA</h1>
        </div>
        <div>
          <h2>
            Administre, controle e faça novos pedidos através da Plataforma,
            aumente sua produtividade e a satisfação de seu cliente.
          </h2>
        </div>
      </div>
      <Background />
      <Content>
        <img src={logoImg} alt="Bib" />
        <Form ref={formRef} onSubmit={handleSubmit}>
          <h5>Nome do usuário</h5>
          <Input type="text" name="clientUsername" id="clientUsername" />
          <h5>Senha</h5>
          <Input type="password" name="clientPassword" id="clientPassword" />
          <h5>Confirme Senha</h5>
          <Input
            type="password"
            name="password_confirmation"
            id="password_confirmation"
          />
          <Button loading={loading} type="submit">
            Cadastrar Credenciais
          </Button>
        </Form>
      </Content>
    </Container>
  );
};

export default CriarCredenciais;
